import type { CrmTranslate } from './crm-copy';

export function createCrmCompanyDetailsCopy(t: CrmTranslate) {
  return {
    companyView: {
      fallbacks: {
        company: t('crm.companyView.fallbacks.company'),
        unnamedContact: t('crm.companyView.fallbacks.unnamedContact'),
      },
      empty: {
        selectCompanyTitle: t('crm.companyView.empty.selectCompanyTitle'),
        selectCompanyDescription: t('crm.companyView.empty.selectCompanyDescription'),
        notFoundTitle: t('crm.companyView.empty.notFoundTitle'),
        notFoundDescription: t('crm.companyView.empty.notFoundDescription'),
        noContacts: t('crm.companyView.empty.noContacts'),
      },
      actions: {
        backToCompanies: t('crm.companyView.actions.backToCompanies'),
        edit: t('crm.companyView.actions.edit'),
        delete: t('crm.companyView.actions.delete'),
        cancel: t('crm.companyView.actions.cancel'),
        viewProfile: t('crm.companyView.actions.viewProfile'),
        viewAllContacts: t('crm.companyView.actions.viewAllContacts'),
        view: t('crm.companyView.actions.view'),
      },
      tabs: {
        overview: t('crm.companyView.tabs.overview'),
        contacts: (count: number) =>
          t('crm.companyView.tabs.contacts', {
            values: { count },
          }),
        inbox: t('crm.companyView.tabs.inbox'),
      },
      sections: {
        companyInformation: t('crm.companyView.sections.companyInformation'),
        description: t('crm.companyView.sections.description'),
        companyContacts: t('crm.companyView.sections.companyContacts'),
      },
      labels: {
        name: t('crm.companyView.labels.name'),
        email: t('crm.companyView.labels.email'),
        phone: t('crm.companyView.labels.phone'),
        website: t('crm.companyView.labels.website'),
        domain: t('crm.companyView.labels.domain'),
        address: t('crm.companyView.labels.address'),
        city: t('crm.companyView.labels.city'),
        stateRegion: t('crm.companyView.labels.stateRegion'),
        postalCode: t('crm.companyView.labels.postalCode'),
        country: t('crm.companyView.labels.country'),
        industry: t('crm.companyView.labels.industry'),
        primarySubIndustry: t('crm.companyView.labels.primarySubIndustry'),
        companySize: t('crm.companyView.labels.companySize'),
        employeeCount: t('crm.companyView.labels.employeeCount'),
        employeeRange: t('crm.companyView.labels.employeeRange'),
        revenueRange: t('crm.companyView.labels.revenueRange'),
        foundedYear: t('crm.companyView.labels.foundedYear'),
        ticker: t('crm.companyView.labels.ticker'),
        fax: t('crm.companyView.labels.fax'),
        linkedIn: t('crm.companyView.labels.linkedIn'),
        externalId: t('crm.companyView.labels.externalId'),
        externalProfile: t('crm.companyView.labels.externalProfile'),
        created: t('crm.companyView.labels.created'),
        outreachMotions: t('crm.companyView.labels.outreachMotions'),
        outreachCampaigns: t('crm.companyView.labels.outreachCampaigns'),
        outreachAngles: t('crm.companyView.labels.outreachAngles'),
        outreachPersonas: t('crm.companyView.labels.outreachPersonas'),
        outreachReadiness: t('crm.companyView.labels.outreachReadiness'),
        outreachBlockReason: t('crm.companyView.labels.outreachBlockReason'),
        outreachEvidence: t('crm.companyView.labels.outreachEvidence'),
        outreachSourceUrl: t('crm.companyView.labels.outreachSourceUrl'),
      },
      contacts: {
        loading: t('crm.companyView.contacts.loading'),
        moreContacts: (count: number) =>
          t('crm.companyView.contacts.moreContacts', {
            values: { count },
          }),
      },
      inbox: {
        title: t('crm.companyView.inbox.title'),
        emptyDescription: t('crm.companyView.inbox.emptyDescription'),
      },
      confirmations: {
        deleteTitle: t('crm.companyView.confirmations.deleteTitle'),
        deleteMessage: t('crm.companyView.confirmations.deleteMessage'),
      },
      messages: {
        updateSuccess: t('crm.companyView.messages.updateSuccess'),
        updateFailed: (error: string) =>
          t('crm.companyView.messages.updateFailed', {
            values: { error },
          }),
        updateFailedConsole: t('crm.companyView.messages.updateFailedConsole'),
        missingCompanyId: t('crm.companyView.messages.missingCompanyId'),
        companyNotFound: t('crm.companyView.messages.companyNotFound'),
        fetchFailedConsole: t('crm.companyView.messages.fetchFailedConsole'),
        deleteFailedConsole: t('crm.companyView.messages.deleteFailedConsole'),
      },
    },
  };
}
